module.exports = __webpack_public_path__ + "h5/img/noNews.5f227afa.png";